export default "__VITE_ASSET__dcc397ea__"